import { queryOrderDetail, waitSignOrder, cancelOrder, orderPay, indexFeaturedGet,delayOrderApi } from "@/libs/api.js";
import logistic from "@/components/logistic.vue";
import { mapGetters, mapActions } from "vuex";
import {types as Home} from '@/store/home'
import { getCookie ,systemTime} from "../../../libs/common";

const getters = mapGetters({
	getPioltCity: Home.IS_PIOLICity,
});
export default {
  name: "orderInfo",
	components: { logistic },  
  computed: {
		...getters,
	},
  data() {
    return {
      isShowCanncel: false,
      isShowLogistic: false,
      currentCanncel: 1,
      canncelList: [],
      orderStatus: 0,
      businessType:'',
      orderTag:'',
      showPage: false,
      orderInfo: {},
      transAddress: "",
      transName: "",
      transPhone: "",
      serviceState: false, // 客服在线状态
      serviceUrl: "",
      systemTime:null,
    };
  },
  created() {
    systemTime(time=>{
      this.systemTime=time;
    })
  },
  mounted() {
    this.getOrderDetail(this.$route.params.escOrderId);
  },
  beforeCreate() {},
  methods: {
    onBack() {
      history.back();
    },
    getOrderDetail(orderId) {
      this.$toast.loading({
        duration: 0,
        mask: true,
        message: "加载中...",
      });
      let data = {
        escOrderId: orderId,
        clientCallType: "H5",
      };
      queryOrderDetail(data, "jsonCallback")
        .then((res) => {
          console.log(res);
          if (res.code === "0000" && res.data) {
            this.showPage = true;
            this.orderInfo = res.data.order;
            this.orderInfo.delevery&&this.orderInfo.delevery.forEach(items=>{
              items.prd&&items.prd.forEach(item=>{
                if(this.orderInfo.orderType=='1405'&&this.orderInfo.orderTag.indexOf("100027")>-1 && items.completeTimestamp>0){
                  //优鲜试点订单，签收48小时以内才可以申请退换货
                  let now = this.systemTime || new Date().getTime(),
                      timeDiff=(now - items.completeTimestamp),time48h=48*60*60*1000;
                      if(timeDiff>=time48h){
                        item.overTime=true;
                      }
                }
              })
            })
            
            this.orderStatus = res.data.order.orderStatus;
            this.transAddress = this.orderInfo.transProvince + this.orderInfo.transCity + this.orderInfo.transArea + this.orderInfo.transTown + this.orderInfo.transAddress || "";
            this.transName = this.orderInfo.transName || "";
            this.transPhone = this.orderInfo.transPhone || "";
            this.orderTag = this.orderInfo.orderTag || "";
            this.businessType = this.orderInfo.businessType || "";
            this.unionId = this.orderInfo.unionId || "";//优鲜接龙订单是判断unionId=1016039299 不需要跳转到详情页
            // 试点城市订单显示团长信息
						if (res.data.order&&res.data.order.orderTag.indexOf('100027') >=0 ) {
								this.orderInfo.isPolitCity = true;
							}
          }
          this.$toast.clear();
          this.getKefu(this.orderInfo.storeId, this.orderInfo.sellerOnlyid);
        })
        .catch((error) => {
          this.$toast("查询失败哦！");
        });
    },
    // 是否跳转详情页
    isToDetail(listingId) {
      if(this.unionId!="1016039299"){//优鲜接龙订单是判断 unionId=1016039299 不需要跳转到详情页
        this.toNext('/item/itemPage/' + listingId);  
      }
    },
    // 选择取消理由
    selectCanncel(radio) {
      this.currentCanncel = radio;
    },
    // 关闭理由框弹层
    closeCanncelPop() {
      this.isShowCanncel = false;
      this.currentCanncel = 1;
    },
    // 关闭物流弹层
    closeLogisticPop() {
      this.isShowLogistic = false;
    },
    lookLogictic() {
      if (/100008/.test(this.orderInfo.orderTag) && /1016039299/.test(this.orderInfo.unionId)) {
        this.isShowLogistic = true;
      } else {
        this.toNext(`/order/logistics/${this.orderInfo.delevery[0].packageId}`)
      }
    },
    // 弹出取消理由层
    cancelOrderClick() {
      this.isShowCanncel = true;
      this.canncelList = [];
      indexFeaturedGet("jsonpCallback").then((res) => {
        if (res.returnCode === "0000") {
          res.indexInfo.forEach((item, index) => {
            this.canncelList.push({
              name: item.attribute1,
              id: item.id,
              radio: index + 1,
            });
          });
        }
      });
    },
    // 确认取消
    canncelHandel() {
      this.$toast.loading({
        duration: 0,
        mask: true,
        message: "处理中...",
      });
      let cancelReason = "";
      this.canncelList.forEach((item) => {
        if (item.radio === this.currentCanncel) {
          cancelReason = item.name;
        }
      });
      let data = {
        orderId: this.$route.params.escOrderId,
        cancelReason,
        clientCallType: "H5",
      };
      cancelOrder(data, "jsonCallback")
        .then((res) => {
          if (res.code === "0000") {
            this.$toast("操作成功");
            this.$router.go(0);
          } else {
            this.$toast(res.msg);
          }
        })
        .catch((error) => {
          this.$toast("操作失败！");
        });
      this.isShowCanncel = false;
    },
    userSignOrder() {
      let data = {
        escOrderId: this.$route.params.escOrderId,
        clientCallType: "H5",
      };
      waitSignOrder(data, "jsonCallback")
        .then((res) => {
          console.log(res);
          if (res.code === "0000") {
            this.$toast("操作成功");
            this.$router.go(0);
          } else {
            this.$toast(res.msg);
          }
        })
        .catch((error) => {
          this.$toast("查询失败！");
        });
    },
    payMent() {
      //确认付款
      let data = {
        escOrderIds: this.$route.params.escOrderId,
        clientCallType: "H5",
      };
      orderPay(data)
        .then((res) => {
          if (res.returnCode === "0000") {
            location.href = res.data.payUrl;
          } else {
            this.$toast(res.returnMessage);
          }
        })
        .catch((error) => {
          this.$toast("支付失败！");
        });
    },
    // 获取客服
    getKefu(storeId, merchantId) {
      console.log(storeId, merchantId);
      this.$axios
        .post(`//livechat.${this.$uleUrl()}/uleImService/imService/custServOnlineStatu`, {
          storeId: storeId,
          merchantId: merchantId,
          source: "order",
        })
        .then((res) => {
          let data = res.data;
          if (data.returnCode === "0000" || data.code === "0000") {
            switch (data.data.status) {
              case "offline":
                this.serviceState = false; // 不在线
                break;
              case "online":
                this.serviceState = true; // 在线
                break;
              default:
            }
            this.serviceUrl = `https://livechat.${this.$uleUrl()}/imweb/visitorBusinessMobile?channel=yxdsq&source=order&merchantId=${merchantId}&storeId=${storeId}&orderId=${this.$route.params.escOrderId}`;
          }
        });
    },
    //跳转申请售后页面
    toRefund(escOrderid, deleveryOrderid, itemid, orderType,orderTag,completeTime) {
      // 邮储信用卡商城订单 不支持在大网申请退换货 add 20201124
      if(orderType == '3101' || orderType == '3110'){
        this.$toast(orderType == '3110'? '您的订单是邮惠购商城订单，请前往邮惠购商城申请退换货。邮乐商城不支持邮惠购订单申请退换货操作。':'您的订单是邮储商城订单，请前往邮储商城申请退换货。邮乐商城不支持邮储订单申请退换货操作。');
        return;
      }
      
      let client_type = "&client_type=";
      if (this.$browser().ule) {
        client_type = "";
      } else {
        client_type = client_type + "ylxdsq";
      }
      if(orderType == '3108'||orderType == '3111'){
        location.href ='https://my.' + this.$uleUrl() +'/myReturnOrderWapWeb/psbcMobileSelectReturn.do?uleNeedH5Title=true&escOrderid=' +
        escOrderid +
        "&deleveryOrderid=" +
        deleveryOrderid +
        "&itemid=" +
        itemid +
        client_type;
      }else if(orderType=='1405'&&orderTag.indexOf("100027")>-1&&(this.getPioltCity || getCookie('ispioltCity'))){
        //判断是否在签收48小时内
        systemTime(time=>{
          let now = time || new Date().getTime(),
              timeDiff=(now - completeTime),time48h=48*60*60*1000;
          if(timeDiff>=time48h && completeTime && completeTime>0){
            this.$toast("已经超过48小时，无法申请退款");
          }else{
            //优鲜试点城市申请退换货去优鲜退换货页面
            location.href ='https://my.' + this.$uleUrl() +'/myReturnOrderWapWeb/fresh/mobileSelectReturn.do?uleNeedH5Title=true&escOrderid=' +
            escOrderid +
            "&deleveryOrderid=" +
            deleveryOrderid +
            "&itemid=" +
            itemid +
            client_type;
              }
        })
        
      }else{
        location.href =
        "https://my." +
        this.$uleUrl() +
        "/myReturnOrderWapWeb/mobileSelectReturn.do?uleNeedH5Title=true&escOrderid=" +
        escOrderid +
        "&deleveryOrderid=" +
        deleveryOrderid +
        "&itemid=" +
        itemid +
        client_type;
      }
    },
    // 延迟收货
    toDelay (orderId) {
      delayOrderApi({
        orderId,
        clientCallType: 'H5'
      })
        .then(res => {
          if (res.returnCode == '0000') {
            this.orderInfo.isAbleDelay = '2'
            this.$toast('延迟成功')
          } else {
            this.$toast(res.returnMessage)
          }
        })
    },
    // 查看核销码
    handleWriteOff() {
      // console.log("核销");
      window.location.href = this.orderInfo.qrUrl
    },
    handleToInvoice(escOrderId,type){
      if(type == 0){
        window.location.href = `https://h5.${this.$uleUrl()}/yxd/mall/order/invoice?escOrderId=${escOrderId}`
      }else{
        window.location.href = `https://h5.${this.$uleUrl()}/yxd/mall/order/invoiceView?escOrderId=${escOrderId}`
      }
    },
  },
};
